import React from "react";
import "./App.css";
import Dashboard from "./Components/Dashboard";

function App() {
  // const [users, setUsers] = useState([]);

  // useEffect(() => {
  //   fetch("/api/users")
  //     .then((res) => res.json())
  //     .then((json) => setUsers(json.users));
  //   // Specify how to clean up after this effect:
  //   return () => {};
  // }, []); // empty 2nd arg - only runs once

  return (
    <div className="App">
      <Dashboard />
    </div>
  );
}

export default App;
